<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="add-financial">
      <div class="filter-search">
        <el-form :inline="true" :rules="rules" :model="searchData" ref="searchForm">
          <el-form-item label="媒体商ID：" prop="UserId">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model.number="searchData.UserId" clearable placeholder="请输入媒体商ID"></el-input>
          </el-form-item>
          <el-form-item label="公司名称：">
            <el-input size="small" v-model="searchData.CompanyName" clearable placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="媒体运营：">
            <el-select size="small" v-model="searchData.SourceOperatorId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in SourceOperatorUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="媒介：">
            <el-select size="small" v-model="searchData.SourcemanId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in SourceUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getPrepaidMediaList">查询</el-button>
            <a class="export-button" :disabled="!ExportPrepaidMediaDataPower" :href="exportUrl" target="_blank">导出数据</a>
            <div class="import-button">
              <el-button type="primary" size="small" :disabled=" ! ImportPrepaidMediaUserPower">
                导入数据
              </el-button>
              <input type="file" ref="uploadFile" :disabled="! ImportPrepaidMediaUserPower" @change="previewImportData" class="import-file">
            </div>
            <el-button type="primary" size="small" :disabled="!AddPrepaidMediaUserPower" @click="addPrepaidMedia">添加预付媒体商</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-type">
        <span class="el-icon-menu data-size">审核数据（{{dataSize}}）</span>
        <!-- <el-button type="default" @click="changeType">媒体结算</el-button> -->
        <!-- <el-button type="primary">财务添加</el-button> -->
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
          <el-table-column align="center" fixed="left" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="resolveCheck(scope.row)" type="text" size="small">账单明细</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="UserId" label="媒体商ID" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="CompanyName" label="公司名称" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceOperatorName" label="媒体运营" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourcemanName" label="媒介" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="ContractCompany" label="合同公司" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="DevBalance" label="账户余额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SumSettlementAmount" label="累计结算金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="CumulativePrepaidAmount" label="累计预付金额" min-width="130">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 弹层设置 -->
    <addMedia :isShowdialog="isShowDiaLog" @close='closeDialog' :dialogPragram="dialogPragram"></addMedia>
    <previewMediaPrepaid :isShowPreview="isShowPreview" @close='closePreview' :dialogPragram="dialogPragram"></previewMediaPrepaid>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
import addMedia from "../public/import-preview/add-media-dialog";
import previewMediaPrepaid from "../public/import-preview/preview-Prepaid-dialog";
import { XLSX } from "common/js/myexcel";
// api
import {
  GetPrepaidMediaList,
  getSourceOperatorUserList,
  getSourceUserList,
  AddPrepaidMediaUser,
  ImportPrepaidMediaUser
} from "api/mediaWithdraw";

export default {
  data() {
    var validateUserId = (rule, value, callback) => {
      if (value != "") {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error("请填写数字！"));
        } else if (value > 999999999) {
          callback(new Error("输入不能超过9个字符"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      searchData: {
        UserId: "",
        CompanyName: "",
        SourcemanId: "",
        SourceOperatorId: ""
      },
      rules: {
        UserId: [{ validator: validateUserId, trigger: "change" }]
      },
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "财务添加",
          href: ""
        }
      ],
      dataSize: 0,
      isShowDiaLog: false,
      isShowPreview: false,
      dialogPragram: {
        title: "提示",
        callback: null,
        tableData: []
      },
      tableData: [],
      SourceOperatorUserList: [],
      SourceUserList: [],
      updateFile: ""
    };
  },
  computed: {
    exportUrl() {
      var filterData = {
        userId: this.searchData.UserId,
        companyName: this.searchData.CompanyName,
        sourceOperatorId: this.searchData.SourceOperatorId,
        SourcemanId: this.searchData.SourcemanId
      };
      var url = `/IAD_PrepaidMedia/ExportPrepaidMediaData?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    },
    AddPrepaidMediaUserPower() {
      if (this.$store.state.authorization.IAD_PrepaidMedia) {
        if (this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs) {
          return this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs
            .AddPrepaidMediaUser;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ImportPrepaidMediaUserPower() {
      if (this.$store.state.authorization.IAD_PrepaidMedia) {
        if (this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs) {
          return this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs
            .ImportPrepaidMediaUser;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ExportPrepaidMediaDataPower() {
      if (this.$store.state.authorization.IAD_PrepaidMedia) {
        if (this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs) {
          return this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs
            .ExportPrepaidMediaData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  components: {
    crumbs,
    addMedia,
    previewMediaPrepaid
  },
  methods: {
    // 获取媒体运营数据
    initData() {
      getSourceOperatorUserList().then(res => {
        this.SourceOperatorUserList = Object.assign(
          {},
          this.SourceOperatorUserList,
          res.list
        );
      });
      getSourceUserList().then(res => {
        this.SourceUserList = Object.assign({}, this.SourceUserList, res.list);
      });
    },
    // 获取预付商列表
    getPrepaidMediaList() {
      var filterData = {
        UserId: this.searchData.UserId,
        CompanyName: this.searchData.CompanyName,
        SourcemanId: this.searchData.SourcemanId,
        SourceOperatorId: this.searchData.SourceOperatorId
      };
      this.$nextTick(() => {
        this.$refs["searchForm"].validate(valid => {
          if (valid) {
            GetPrepaidMediaList(filterData)
              .then(res => {
                if (res.list) {
                  this.tableData = res.list;
                  this.dataSize = res.list.length;
                } else {
                  this.tableData = [];
                  this.dataSize = 0;
                }
              })
              .catch(err => {
                this.tableData = [];
                this.dataSize = 0;
              });
          } else {
            return false;
          }
        });
      });
    },
    closeDialog(type) {
      this.isShowDiaLog = false;
      if (type) {
        this.getPrepaidMediaList();
      }
    },
    previewImportData(e) {
      var that = this;
      var f = e.target.files[0];
      if (f) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result;
          var wb = XLSX.read(data, {
            type: "binary"
          });
          var jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          if (jsonData.length > 99) {
            that.$alert("导入数据条数不能超过100条", "警告", {
              type: "warning",
              center: true
            });
            that.$refs.uploadFile.value = "";
          } else {
            this.updateFile = jsonData;
            that.isShowPreview = true;
            that.dialogPragram.tableData = jsonData;
          }
        };
        reader.readAsBinaryString(f);
      }
    },
    // 关闭预览
    closePreview(data) {
      var uploadDataTemplate = {
        UserId: "媒体商ID",
        PretaxAmount: "预付金额",
        Remark: "备注"
      };
      if (data) {
        var uploadInfo = this.formatUploadData(data, uploadDataTemplate);
        ImportPrepaidMediaUser(uploadInfo).then(res => {
          this.isShowPreview = false;
          this.$refs.uploadFile.value = "";
          this.getPrepaidMediaList();
        });
      } else {
        this.isShowPreview = false;
        this.$refs.uploadFile.value = "";
      }
    },
    formatUploadData(data, uploadDataTemplate) {
      var uploadData = [];
      data.forEach(function(ele) {
        var tempObj = {};
        for (var key in ele) {
          for (var key2 in uploadDataTemplate) {
            if (key === uploadDataTemplate[key2]) {
              tempObj[key2] = ele[key];
            }
          }
        }
        uploadData.push(tempObj);
      });
      return uploadData;
    },
    addPrepaidMedia() {
      this.dialogPragram.title = "添加预付媒体商";
      this.dialogPragram.callback = AddPrepaidMediaUser;
      this.isShowDiaLog = true;
    },
    resolveCheck(data) {
      this.$router.push({ name: "billDetail", params: { id: data.UserId } });
    }
  },
  created() {
    document.title = "财务添加";
    this.initData();
    this.getPrepaidMediaList();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    if (to.name === "billDetail") {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    } else {
      from.meta.keepAlive = false;
      // to.meta.keepAlive = false;
      this.$destroy();
      next();
    }
  },
  activated() {
    this.getPrepaidMediaList();
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.add-financial {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-input {
      width: 150px;
    }
    .el-select {
      .el-input {
        width: 120px;
      }
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin-left: 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
    .import-button {
      margin-left: 10px;
      margin-right: 10px;
      display: inline-block;
      position: relative;
      .import-file {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
      font-size: 14px;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-button {
      margin: 0;
      width: 100%;
      font-size: 14px;
    }
    thead {
      tr {
        background-color: #f5f5f5 !important;
        border-bottom: 2px solid #bbb;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/add-financial.vue